import ApiAgentInterface from "../ApiAgentInterface";

class BizApiAgent extends ApiAgentInterface {
    constructor(requestModule, urlBasePromise, queryParamStringStrategy) {
        super();
        this.requestModule = requestModule;
        this.urlBasePromise = urlBasePromise;
        this.queryParamStringStrategy = queryParamStringStrategy;
    }

    get = async (path, queryParam={}) => {
        const url = await this._getRequestUrl(path, queryParam);
        return this.requestModule.get(url);
    }

    post = async (path, data, queryParam={}) => {
        const url = await this._getRequestUrl(path, queryParam);
        return this.requestModule.post(url, data);
    }

    _getRequestUrl = async (endpointPath, queryParam) => {
        // if urlBase has a trailing slash, then remove it
        let urlBase = await this.urlBasePromise;
        if (urlBase.endsWith("/") === true) {
            urlBase = urlBase.slice(0, -1);
        }

        // if path does not have a leading slash, then add one
        let path = endpointPath;
        if (path.startsWith("/") === false) {
            path = "/" + path;
        }

        const queryParamString = this.queryParamStringStrategy.build(queryParam);

        const requestUrl = urlBase + path + queryParamString;
        return requestUrl;
    }
}

export default BizApiAgent;